module.exports = __webpack_public_path__ + "img/attribute-check@3x.c27fa3cf.png";